<div class="file-download-one-action-list-item">
  <div class="file-download-item">
    <core-file-name-download
        [file]="file"
    ></core-file-name-download>
    </div>
    <div  class="file-download-group">
      <div *ngIf="bubble" class="bubble">
          <span (click)="onBubbleClick(file)" [innerHTML]="bubbleNumber">{{ bubbleNumber }}</span>
      </div>
      <div *ngIf="actionText !=''" class="action {{actionStyle}}">
          <span ><em (click)="onActionClick(file)" [innerHTML]="actionText">{{ actionText }}</em></span>
      </div>
      <div class="download-extension">
          <span [innerHTML]="file.extension">{{file.extension}}</span>
      </div>
    </div>
</div>
